import IconeAjuda from '@/global/components/IconeAjuda'
import Menu from '@/global/components/MenuV2'
import Grid from '@/global/components/ui/Grid'
import { Divider } from '@mui/material'
import { FormField, FormFieldCheckbox } from 'global/components/Form'
import { useFormContext } from 'react-hook-form'
import { horariosCalculoAutomatico } from 'templates/Cadastro/Empresas/constants/horarios'

export default function CalculoAutomatico() {
    const { watch, setValue } = useFormContext()

    const hrCalculoAutomatico = watch('hrCalculoAutomatico')
    const calculoAutomatico = watch('calculoAutomatico')

    return (
        <section id="calculo-automatico">
            <Divider
                sx={{
                    mt: 4,
                    mb: 3,
                    userSelect: 'none',
                }}
            >
                <span className="inline-flex items-center">
                    Cálculo automático&nbsp;
                    <IconeAjuda>
                        O cálculo automático é realizado uma vez ao dia, no
                        horário selecionado. Ele é responsável por gerar os
                        espelhos de ponto e calcular as jornadas de trabalho de
                        todos os funcionários da empresa.
                        <br />
                        <br />
                        Se o cálculo automático estiver desabilitado, você
                        precisará realizar o cálculo manualmente através do
                        botão "Calcular ponto" na tela de digitação ou de
                        cálculo de ponto sempre que desejar atualizar os
                        espelhos e saldos dos funcionários.
                    </IconeAjuda>
                </span>
            </Divider>
            <Grid container spacing={1} columnSpacing={2}>
                <Grid item xs={6} className="inline-flex items-center mt-2">
                    <FormFieldCheckbox
                        name="calculoAutomatico"
                        label="Habilitar cálculo automático"
                        defaultChecked={!!hrCalculoAutomatico}
                        onChange={(_, checked) => {
                            if (checked) {
                                setValue('hrCalculoAutomatico', null)
                            } else {
                                setValue('hrCalculoAutomatico', -1)
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={6}>
                    <FormField
                        id="hrCalculoAutomatico"
                        name="hrCalculoAutomatico"
                        label="Horário do cálculo automático"
                        select
                        disabled={!calculoAutomatico}
                    >
                        <Menu.Item value={-1} disabled>
                            Selecione uma opção
                        </Menu.Item>
                        {horariosCalculoAutomatico.map((horario, index) => (
                            <Menu.Item key={index} value={horario}>
                                {horario}
                            </Menu.Item>
                        ))}
                    </FormField>
                </Grid>
            </Grid>
        </section>
    )
}
